import { create } from "zustand";
import type { User } from "../types/domain.types";

/**
 * Store de autenticacion.
 * El accessToken se guarda en MEMORIA (nunca localStorage) para mitigar XSS.
 * El refreshToken vive solo en cookie HttpOnly emitida por el backend.
 */
interface AuthState {
  user: User | null;
  accessToken: string | null;
  isHydrating: boolean;
  setAuth: (accessToken: string, user: User) => void;
  setAccessToken: (accessToken: string | null) => void;
  setUser: (user: User | null) => void;
  setHydrating: (hydrating: boolean) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  isHydrating: true,
  setAuth: (accessToken, user) => set({ accessToken, user }),
  setAccessToken: (accessToken) => set({ accessToken }),
  setUser: (user) => set({ user }),
  setHydrating: (isHydrating) => set({ isHydrating }),
  clear: () => set({ user: null, accessToken: null }),
}));

/**
 * Selector utilitario sin suscripcion (para usar fuera de React, en el interceptor axios).
 */
export const authStoreApi = {
  getAccessToken: () => useAuthStore.getState().accessToken,
  setAccessToken: (token: string | null) =>
    useAuthStore.setState({ accessToken: token }),
  clear: () => useAuthStore.getState().clear(),
};
